import React, { useState, useEffect } from "react";

import linkedin from "../../img/icon/social-linkedin.svg";
import instagram from "../../img/icon/social-instagram.svg";
import gitHub from "../../img/icon/social-gitHub.svg";
import email from "../../img/icon/social-email.svg";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    var btnOppenNav = document.getElementById("btnOppenNav");
    var btnCloseNav = document.getElementById("btnCloseNav");
    const navbar = document.getElementById("navbar");

    btnOppenNav.addEventListener("click", () => {
      navbar.classList.add("showNavBarMob");
    });

    btnCloseNav.addEventListener("click", () => {
      navbar.classList.remove("showNavBarMob");
    });

    const btnToTop = document.querySelector(".btnBackToTop");

    const handleScroll = () => {
      const loader = document.querySelector(".loader");

      if (window.scrollY > 50) {
        setIsScrolled(true);
        if (loader) loader.classList.add("removeMouseIcon");
      } else {
        setIsScrolled(false);
        if (loader) loader.classList.remove("removeMouseIcon");
      }

      if (btnToTop) {
        if (window.scrollY > 600) {
          btnToTop.classList.add("btnBackToTopShow");
        } else {
          btnToTop.classList.remove("btnBackToTopShow");
        }
      }

      const sections = document.querySelectorAll("section");
      let currentSection = "home";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        if (window.scrollY >= sectionTop - sectionHeight / 3) {
          currentSection = section.getAttribute("id");
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav className="navbar d-flex-column" id="navbar">
      <div className="navBarMobile hiddenNavBarMobile">
        <div className="navBarMob-header">
          <div className="navBarMob-headerText">
            <h1>Lucas</h1>
            <p className="paragraph textProg">Programador Web</p>
          </div>
        </div>
        <button className="buttonNavBarMobile" id="btnCloseNav">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <ul className={`navbarUl d-flex-row ${isScrolled ? "navbarFixed" : ""}`}>
        <p className="navBarMob-sectionTitle hiddenNavBarMobile">Seções</p>
        <li
          className={`${
            activeSection === "sectionAboutMe" ? "itemNavBarActive" : ""
          } ${isScrolled ? "navbarFixedItem" : ""}`}
        >
          <a href="#sectionAboutMe" className="paragraph navbarItem">
            Sobre
          </a>
        </li>
        <li
          className={`${
            activeSection === "sectionTechnology" ? "itemNavBarActive" : ""
          } ${isScrolled ? "navbarFixedItem" : ""}`}
        >
          <a href="#sectionTechnology" className="paragraph navbarItem">
            Tecnologias
          </a>
        </li>
        <li
          className={`${
            activeSection === "sectionProject" ? "itemNavBarActive" : ""
          } ${isScrolled ? "navbarFixedItem" : ""}`}
        >
          <a href="#sectionProject" className="paragraph navbarItem">
            Projetos
          </a>
        </li>
        <li
          className={`${
            activeSection === "sectionDepositions" ? "itemNavBarActive" : ""
          } ${isScrolled ? "navbarFixedItem" : ""}`}
        >
          <a href="#sectionDepositions" className="paragraph navbarItem">
            Depoimentos
          </a>
        </li>
        <li
          className={`${
            activeSection === "sectionContact" ? "itemNavBarActive" : ""
          } ${isScrolled ? "navbarFixedItem" : ""}`}
        >
          <a href="#sectionContact" className="paragraph navbarItem">
            Contato
          </a>
        </li>
      </ul>
      <div className="listMediaSocial hiddenNavBarMobile">
        <p className="navBarMob-sectionTitle">Mídias socias</p>
        <ul className="navBarMob-listMediaSocial">
          <li>
            <a href="https://www.linkedin.com/in/luccsll/" target="blank">
              <img src={linkedin} alt="Botão com foto do Linkedin"></img>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/luccsll" target="blank">
              <img src={instagram} alt="Botão com foto do Instagram"></img>
            </a>
          </li>
          <li>
            <a href="https://github.com/luccsll" target="blank">
              <img src={gitHub} alt="Botão com foto do GitHub"></img>
            </a>
          </li>
          <li>
            <a
              href="mailto:cttlucas16@gmail.com"
              target="blank"
              rel="noopener noreferrer"
            >
              <img src={email} alt="Botão com foto do Email"></img>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
